<div class="page-purchases">
    <div class="d-flex align-items-center title-purchases mobile">
        <span (click)="backTab()"><i class="icon-back fa-light fa-arrow-left"></i></span>
        <p class="name-profile m-0" (click)="backTab()">Atrás</p>
    </div>
    <div class="tab-tickets loading-height">
        <!-- Header -->
        <div class="section d-flex align-items-center header-tickets-profile">
            <h2 class="title">Mis entradas</h2>
        </div>
        <!-- Tickets list -->
        <div #containerEvents>
            <div *ngFor="let group of purchasesByMonth" class="purchase-accordion">
                <div class="accordion-header header-purchase d-flex justify-content-between align-items-center"
                    (click)="toggleGroup(group)" style="cursor: pointer;">
                    <h3 class="m-0 title-purchase" style="text-transform: capitalize; font-size: 22px;">{{ group.month
                        }}</h3>
                    <i class="fa-light" [ngClass]="group.open ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                </div>

                <div [ngClass]="{ 'show': group.open, 'hide': !group.open }" class="accordion-body">
                    <div *ngFor="let item of group.items">
                        <div class="header-purchase d-flex justify-content-between align-items-end"
                            [class.header-refunded]="item.status == 'refunded' && item.refund">
                            <div>
                                <p class="m-0 title-purchase">Pedido #{{ item.idOdoo }}</p>
                                <p class="m-0 date-purchase">{{ item.createdAt | date: 'dd/MM/yyyy - HH:mm' }}h</p>
                            </div>
                            <div class="d-flex options-purchase" *ngIf="item.status != 'refunded' || !item.refund">
                                <div (click)="printPurchase(item.idOdoo)">
                                    <p class="m-0">Descargar pedido</p>
                                </div>
                            </div>
                            <div class="d-flex option-refunded" *ngIf="item.status == 'refunded' && item.refund">
                                <p class="m-0">Pedido devuelto</p>
                            </div>
                        </div>

                        <div #containerEvents>
                            <app-tickets-list (closeAction)="closeAction($event)" [compra]="item" [type]="index">
                            </app-tickets-list>
                        </div>
                    </div>
                </div>
            </div>



            <!-- <div *ngFor="let item of purchases">
                <div class="header-purchase d-flex justify-content-between align-items-end"
                    [class.header-refunded]="item.status == 'refunded' && item.refund">
                    <div>
                        <p class="m-0 title-purchase">Pedido #{{item.idOdoo}}</p>
                        <p class="m-0 date-purchase">{{item.createdAt | date:'dd/MM/yyyy - HH:mm'}}h</p>
                    </div>
                    <div class="d-flex options-purchase" *ngIf="item.status != 'refunded' || !item.refund">
                        <div (click)="printPurchase(item.idOdoo)">
                            <p class="m-0">Descargar pedido</p>
                        </div>
                    </div>
                    <div class="d-flex option-refunded" *ngIf="item.status == 'refunded' && item.refund">
                        <p class="m-0">Pedido devuelto</p>
                    </div>
                </div>
                <div #containerEvents>
                    <app-tickets-list (closeAction)="closeAction($event)" [compra]="item" [type]="index">
                    </app-tickets-list>
                </div>
            </div> -->
        </div>
        <!-- Loading Tickets -->
        <div class="loading-container" *ngIf="loadingPage">
            <ng-lottie class="lottie" [options]="loadingLottie" containerClass="loading-box"></ng-lottie>
        </div>
    </div>
</div>